import { render, staticRenderFns } from "./tdcfreightReduction.vue?vue&type=template&id=9c46d144&"
import script from "./tdcfreightReduction.vue?vue&type=script&lang=js&"
export * from "./tdcfreightReduction.vue?vue&type=script&lang=js&"
import style0 from "./tdcfreightReduction.vue?vue&type=style&index=0&id=9c46d144&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c46d144')) {
      api.createRecord('9c46d144', component.options)
    } else {
      api.reload('9c46d144', component.options)
    }
    module.hot.accept("./tdcfreightReduction.vue?vue&type=template&id=9c46d144&", function () {
      api.rerender('9c46d144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/freightReduction/tdcfreightReduction.vue"
export default component.exports